import {Component, OnInit} from '@angular/core';
import { NavParams, ToastController, ViewController} from "ionic-angular";
import { ClubProvider } from '../../../../providers/club/club';

/**
 * Generated class for the ClubDetailsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'club-details',
  templateUrl: 'club-details.html'
})
export class ClubDetails implements OnInit{

  club;

  constructor(private viewCtrl: ViewController,
    private navParams: NavParams,
    private clubProvider: ClubProvider,
    public toastCtrl: ToastController  ) {

  }

  ngOnInit() {
    this.club = this.navParams.get('club');
    console.log(this.club);
  }

  joinClub(id) {
    this.clubProvider.join(id).subscribe((res) => {
      if (res.success) {
        let toast = this.toastCtrl.create({
          message: 'Vous avez rejoint le club',
          duration: 3000,
          position: 'top'
        });
        toast.present();
        this.dismiss();
      }
    })
  }


  dismiss() {
    this.viewCtrl.dismiss();
  }


}



// WEBPACK FOOTER //
// ./src/pages/employee/network/club-details/club-details.ts